export function formatDate(str) {
  if (!str) return '';
  const d = new Date(str);
  // If the string isn't a parseable date (e.g. weekly labels like "15–21 Mar"),
  // return it as-is instead of producing NaN/NaN.
  if (isNaN(d.getTime())) return str;
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

export function parseFunnelSteps(funnelData) {
  if (!funnelData?.results?.length) return [];
  // PostHog returns funnel steps as a flat array: results[0] = step 1, results[1] = step 2, etc.
  return funnelData.results.map((step) => ({
    label: step.name || step.custom_name || step.action_id || 'Step',
    count: step.count ?? 0,
  }));
}
